import React from 'react';

const Icon = ({ size = '35', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 35 35" fill="none" {...other}>
            <path
                clipRule="evenodd"
                d="M6.597 20.757C4.841 12.022 13.425 5.93 17.68 3.495l.208-.118c.665-.372 1.51-.2 1.967.402 3.703 4.87 9.355 14.125 6.333 18.895-2.442 3.855-7.671 4.869-11.77 4.163-3.304-.569-7.094-2.465-7.82-6.08Z"
                stroke="white"
                strokeWidth="2"
            />

            <path d="m21.477 18.295-4.038 3.978-4.712-3.978M17.5 15.91v16.704" stroke="white" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};
export default React.memo(Icon);
